import AntdDatePicker from "antd/es/date-picker";

const RangePicker = AntdDatePicker.RangePicker;

export { RangePicker };
